'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _auth = require('./redux/modules/auth');

var _containers = require('./containers');

var _Router = require('./helpers/Router');

var _Product = require('./helpers/Product');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
  // const requireLogin = (nextState, replace, cb) => {
  //   function checkAuth() {
  //     const { auth: { user }} = store.getState();
  //     if (!user) {
  //       // oops, not logged in, so can't be here!
  //       replace('/');
  //     }
  //     cb();
  //   }
  //
  //   if (canLoadAuth(store.getState())) {
  //     store.dispatch(loadAuth()).then(checkAuth);
  //   } else {
  //     checkAuth();
  //   }
  // };


  var validateQueryParam = function validateQueryParam(nextState) {
    var query = nextState.location.query;
    return (0, _Router.validateAppQueryParam)(query);
  };

  var checkProductNameAndRealmExist = function checkProductNameAndRealmExist() {
    var auth = store.getState().auth;
    return auth.productName && auth.realm;
  };

  // For Query Params
  var checkQueryParams = function checkQueryParams(nextState, replace, cb) {
    function checkAuth() {
      if (!validateQueryParam(nextState) || !checkProductNameAndRealmExist()) {
        replace('/');
      }
      cb();
    }
    if ((0, _auth.canLoad)(store.getState())) {
      var promise = store.dispatch((0, _auth.load)());
      promise.then(function () {
        checkAuth();
      });
      promise.catch(function () {
        replace((0, _Router.getErrorRetryPath)(nextState.location.query));
        cb();
      });
    } else {
      checkAuth();
    }
  };

  /**
   * Please keep routes in alphabetical order
   */
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.NotFound }),
    _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.Version, component: _containers.Version }),
    _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.NotFound, component: _containers.NotFound }),
    _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.ErrorRetry, component: _containers.ErrorRetry }),
    _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.ValidateSSO, component: _containers.ValidateSSO }),
    _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.TVCodeForm, component: _containers.TV }),
    _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.CodeForm, component: _containers.TV }),
    _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.TVLoginSuccess, component: _containers.TVLoginSuccess }),
    _react2.default.createElement(
      _reactRouter.Route,
      { onEnter: checkQueryParams },
      _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.QRLogin, component: _containers.QRLogin }),
      _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.QRSignUp, component: _containers.QRSignUp }),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: _Router.RouterConst.Welcome, component: _containers.Welcome },
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.ExistingAccount, component: _containers.ExistingAccount }),
        _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.LoginSignUp }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.LoginEmail, component: _containers.LoginEmail }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.LoginOptions, component: store.getState().auth.platform === _Product.PLATFORM_NAMES.SmartSpeaker ? _containers.LoginOptions : _containers.LoginEmail }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.SignUpEmail, component: _containers.SignUpEmail }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.SignUpOptions, component: _containers.SignUpEmail }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.Communication, component: _containers.Communication }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.TopProviders, component: _containers.TopProviders }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.AllProviders, component: _containers.AllProviders }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.ProviderNotListed, component: _containers.ProviderNotListed }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.Authorization, component: _containers.Authorization }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.AuthorizationError, component: _containers.AuthorizationError }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.AuthorizationNow, component: _containers.AuthorizationMobile }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.AuthorizationOptions, component: _containers.AuthorizationOptions }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.SwitchProvider, component: _containers.SwitchProvider }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.Addresses, component: _containers.Addresses }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.LinkAccount, component: _containers.LinkAccount }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.LinkExpired, component: _containers.LinkExpired }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.TrialExpired, component: _containers.TrialExpired }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.AuthorizationExpired, component: _containers.AuthorizationExpired }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.AuthorizationSSOSuccess, component: _containers.AuthorizationSSOSuccess }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.ApproveAgreements, component: _containers.ApproveAgreement })
      ),
      _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.ResetPassword, component: _containers.ResetPassword }),
      _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.CreatePasswordAndLinkToProfile, component: _containers.CreatePasswordAndLinkToProfile }),
      _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.ResetPasswordConfirmation, component: _containers.ResetPasswordConfirmation }),
      _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.ResetPasswordExpired, component: _containers.ResetPasswordExpired }),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: _Router.RouterConst.Welcome, component: _containers.Welcome },
        _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.NotFound }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.ForgotPassword, component: _containers.ForgotPassword }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.ConfirmForgotPassword, component: _containers.ConfirmForgotPass }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.ContactUs, component: _containers.ContactUs }),
        _react2.default.createElement(_reactRouter.Route, { path: _Router.RouterConst.ContactUsFeedback, component: _containers.ContactUsFeedback })
      )
    ),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 2041
// module chunks = 0